import {Abstract} from "../step-order/elements/abstract.js";
import formDataAppendObject from "../../utils/form-data-append-object.js";
import Axios from "axios";
import {Response} from "../step-order/response.js";

export class DealTermChange extends Abstract {

	_data;
	_nodeHood;
	_nodeSwitch;
	_nodeConfirm;
	_active;

	static init(form) {
		return super.init(form, '.js-deal-term-change');
	}

	constructor(form, node) {
		super(form, node);

		this._nodeHood = this._node.querySelector('.js-deal-term-change__hood');
		this._nodeSwitch = this._node.querySelectorAll('.js-deal-term-change__switch');
		this._nodeInput = this._node.querySelector('.js-deal-term-change__input');
		this._nodeConfirm = this._node.querySelector('.js-deal-term-change__confirm');
		this._active = this._nodeHood.classList.contains('active');

		this._manageInputGroups(true);
		this._bindEvents();
	}

	getValue(groupId, participantId, type) {
		let self = this;
		if (self._data && self._data[groupId] && self._data[groupId][participantId] && self._data[groupId][participantId][type] && self._data[groupId][participantId][type] !== undefined) {
			return self._data[groupId][participantId][type];
		}

		return '';
	}

	getForm() {
		let self = this;
		return self._form;
	}

	getNode() {
		let self = this;
		return self._node;
	}

	getNodeName() {
		let self = this;
		return self._node.name;
	}

	getData() {
		let self = this;
		return self._nodeInput.value;
	}

	getKidsCount(groupId) {
		let kidsCount = 0;
		let kidsCheckboxElement = document.querySelector('.js-kids-pets-parking__checkbox-kids-' + groupId);
		let kidsCountElement = document.querySelector('.js-kids-pets-parking__kids-count-' + groupId);
		if (kidsCountElement !== null && kidsCheckboxElement !== null && kidsCheckboxElement.checked === true) {
			kidsCount = parseInt(kidsCountElement.value);
		}
		return kidsCount;
	}

	getMinConfig(groupId) {
		let self = this;
		return parseInt(self._node.dataset.min) + this.getKidsCount(groupId);
	}

	getMaxConfig(groupId) {
		let self = this;
		return parseInt(self._node.dataset.max) + this.getKidsCount(groupId);
	}

	enable() {
		let self = this;
		// self._nodeSwitch.disabled = false;
		self._controlHoodVisibility();
	}

	disable() {
		let self = this;
		// self._nodeSwitch.disabled = true;
		self._controlHoodVisibility();
	}

	error(error = null) {
		let self = this;

		// remove old
		self._nodeSwitch.forEach(nodeSwitch => nodeSwitch.classList.remove('invalid'));

		let oldNode = self._nodeSwitch.parentNode.querySelector('.c-deal-term-change-error');
		if (oldNode) {
			oldNode.parentNode.removeChild(oldNode);
		}

		// add new
		if (error) {
			self._nodeSwitch.forEach(nodeSwitch => nodeSwitch.classList.add('invalid'));

			let newNode = document.createElement('div');
			newNode.classList.add('c-deal-term-change-error');
			newNode.innerText = error;

			let lastChildNode = self._nodeSwitch.parentNode.lastChild;
			lastChildNode.parentNode.insertBefore(newNode, lastChildNode.nextSibling);
		}
	}

	notice(notice = null) {
		let self = this;

		// remove old
		let oldNode = self._nodeSwitch.parentNode.querySelector('.c-deal-term-change-notice');
		if (oldNode) {
			oldNode.parentNode.removeChild(oldNode);
		}

		// add new
		if (notice) {
			let newNode = document.createElement('div');
			newNode.classList.add('c-deal-term-change-notice');
			newNode.innerText = notice;

			let lastChildNode = self._nodeSwitch.parentNode.lastChild;
			lastChildNode.parentNode.insertBefore(newNode, lastChildNode.nextSibling);
		}
	}

	value(value) {
		let self = this;
		self._nodeInput = value;
		// self._nodeSwitch.checked = value;
		self._controlHoodVisibility();
	}

	show() {
		let self = this;
		self._node.classList.remove('c-step-order__element--hidden');
	}

	hide() {
		let self = this;
		self._node.classList.add('c-step-order__element--hidden');
	}

	_bindEvents() {
		let self = this;

		self._nodeSwitch.forEach(nodeSwitch => {
			nodeSwitch.addEventListener('click', (e) => {
				e.preventDefault();

				self._controlHoodVisibility();
				// self._form.callElementUpdate(self);

				if (self.isActive()) {
					self._callCheckCallback();
				}
			});
		});



		self._nodeConfirm.addEventListener('click', e => {
			e.preventDefault();
			if (confirm(this._nodeConfirm.dataset.confirmMessage)) {
				self._form.submit();
			}
		});
	}

	isActive() {
		return this._active;
	}

	_controlHoodVisibility() {
		let self = this;


		!self.isActive() ? self._activateHood() : self._deactivateHood();
	}

	_activateHood() {
		let self = this;
		self._nodeHood.classList.add('active');

		self._nodeSwitch.forEach(nodeSwitch => {
			nodeSwitch.classList.toggle('u-hidden');
		});

		self._active = true;
		self._updateInputsRequiredState(true);
		self._updatePrice();
	}

	_deactivateHood() {
		let self = this;
		self._active = false;

		self._nodeSwitch.forEach(nodeSwitch => {
			nodeSwitch.classList.toggle('u-hidden');
		});

		self._nodeHood.classList.remove('active');
		self._updateInputsRequiredState(false);
	}

	_updateFirstParticipant() {
		let self = this;
	}

	_updateInputsRequiredState(required = false) {
		let self = this;


	}

	_updatePrice() {
		setTimeout(() => {

		}, '1000');
	}

	_manageInputGroups(doLoad = false) {
		let self = this;


		self._updateFirstParticipant();
		self._updatePrice()
	}


	_callCheckCallback() {
		let self = this;

		if (self._node.dataset.checkCallback !== 'string') {
			eval.call(window, self._node.dataset.checkCallback);
		}
	}
}
